// HOTFIX 2026-10-31 (Phase 0 follow-up) — pick the REAL MSG91 widget
// access token out of the widget's success payload.
//
// The widget's success payload carries TWO things: the access token (a JWT,
// in the `access-token` field) and a request id (often in `message`).
// The backend now verifies the token with MSG91, so sending the request id
// makes every login fail. Always prefer a JWT-shaped value.
const JWT_RE = /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/;

export function extractMsg91Token(data) {
  if (!data) return '';
  if (typeof data === 'string') return data;
  const candidates = [
    data['access-token'],
    data.accessToken,
    data.access_token,
    data.token,
    data.message,
    data.data && (data.data['access-token'] || data.data.accessToken || data.data.access_token || data.data.token || data.data.message),
  ].filter((v) => typeof v === 'string' && v.trim());
  const jwt = candidates.find((v) => JWT_RE.test(v.trim()));
  return (jwt || candidates[0] || '').trim();
}

export default extractMsg91Token;
